<template>
  <el-dialog class="wrapper" title="选择视频" :visible.sync="dialogVisible">
    <div class="searchWrap">
      <el-input
        v-model="form.materialName"
        size="small"
        :placeholder="$t('lcd.material.Please Input Material Name')"
        @change="handleSearchChange"
        class="searchInput"
        clearable
      ></el-input>
      <el-select
        size="small"
        v-model="form.pixels"
        @change="handleSearchChange"
        class="searchSelect"
        :placeholder="$t('lcd.material.Please Select Material Type')"
        clearable
        filterable
      >
        <el-option
          v-for="item in pixelsList"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>
    <div style="padding: 0px">
      <el-row :gutter="18">
        <el-col
          v-for="video in videoOptions.videoList"
          :key="video.id"
          style="margin-bottom: 18px"
          :xs="12"
          :sm="8"
          :md="8"
          :lg="6"
          :xl="6"
        >
          <el-card
            class="elCard"
            shadow="hover"
            :body-style="{ padding: '0 0 50px 0' }"
          >
            <span class="format">{{ video.pixels }}</span>
            <div
              class="videoWrap"
              @click="handleSelectVideo(video)"
              style="width: 100%; padding: 8px 10px; position: relative"
            >
              <video
                :src="video.url"
                :style="{
                  width: 'auto',
                  'max-width': '100%',
                  'min-height': '120px',
                  height: 'auto',
                  'max-height': '140px',
                  'pointer-events': 'none',
                }"
              />
            </div>
            <div class="materialName">{{ video.materialName }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="videoOptions.current"
      :total="videoOptions.total"
      :page-size="videoOptions.size"
      :page-sizes="videoOptions.sizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      background
    />
  </el-dialog>
</template>

<script>
import store from "../../../store/index.js";
import { attrVideo } from "../../../utils/component-attribute";
import { idxOf } from "../../../utils/common";

export default {
  name: "SelectVideo",
  inject: ["getNewComponentId"],
  data() {
    return {
      form: {
        materialName: "",
        pixels: "",
      },
    };
  },
  props: {
    videoOptions: {
      type: Object,
      default: function () {
        return null;
      },
    },
    pixelsList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.selectVideoDialogVisible;
      },
      set(val) {
        store.updateSelectVideoDialogVisible(val);
      },
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleSearchChange() {
      const val = {
        ...this.form,
      };
      this.$emit("search-change", val);
    },
    // 选择了视频
    handleSelectVideo(video) {
      if (store.state.selectVideoOperation === "ADD_COMPONENT") {
        const conf = JSON.parse(JSON.stringify(attrVideo));
        conf.componentId = this.getNewComponentId();
        conf.videoList.push({
          url: video.url,
          videoId: video.id,
          duration: video.duration,
        });
        store.addComponent(conf);
      } else if (store.state.selectVideoOperation === "ADD_VIDEO") {
        const newProgramData = JSON.parse(
          JSON.stringify(store.state.programInfo)
        );
        const idx = idxOf(
          newProgramData.pages[store.state.currentPageIdx].componentList,
          store.state.activeComponent,
          "componentId"
        );
        // 先将视频list置空
        // console.log("替换视频123");
        newProgramData.pages[store.state.currentPageIdx].componentList[
          idx
        ].videoList = []
        // 添加新的视频信息
        newProgramData.pages[store.state.currentPageIdx].componentList[
          idx
        ].videoList.push({
          url: video.url,
          videoId: video.id,
          duration: video.duration,
        });
        store.updateProgramInfo(newProgramData);
      } else if (store.state.selectVideoOperation === "REPLACE_AD") {
        // 替换营销位视频
        const newProgramData = JSON.parse(
          JSON.stringify(store.state.programInfo)
        );
        const idx = idxOf(
          newProgramData.pages[store.state.currentPageIdx].componentList,
          store.state.activeComponent,
          "componentId"
        );
        // console.log("替换营销位视频123");
        // console.log("newProgramData", newProgramData);
        // console.log("idx", idx);
        // console.log("currentPageIdx", store.state.currentPageIdx);

        newProgramData.pages[store.state.currentPageIdx].componentList[
          idx
        ].adList.splice(0, 1, {
          url: video.url,
          videoId: video.id,
          duration: video.duration,
        });
        store.updateProgramInfo(newProgramData);
        console.log("newProgramData", newProgramData);
        // newProgramData.pages[store.state.currentPageIdx].componentList[
        //   idx
        // ].videoList.push({
        //   url: video.url,
        //   videoId: video.id,
        //   duration: video.duration,
        // });
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  ::v-deep .el-dialog {
    width: 1008px;
    margin-top: 5vh !important;
  }
  ::v-deep .el-dialog__header {
    button {
      font-size: 20px;
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
  .video-list {
    .el-col {
      padding: 6px;
      box-sizing: border-box;
      position: relative;
      > div {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
}
.searchWrap {
  width: 100%;
  padding: 15px 0;
  .searchInput {
    width: 160px;
  }
  .searchSelect {
    margin-left: 10px;
  }
}
::v-deep .el-pagination.is-background button,
.el-pagination.is-background button span,
.el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
::v-deep .el-pagination.is-background .el-pager li {
  height: 28px !important;
  line-height: 28px !important;
}
.elCard {
  position: relative;
  height: 200px;
  .format {
    // width: 40px;
    font-size: 12px;
    line-height: 16px;
    position: absolute;
    background-color: rgba($color: #000000, $alpha: 0.4);
    padding: 3px 8px;
    color: #fff;
    right: 0;
    top: 0;
    border-radius: 0 3px 0 3px;
    z-index: 2;
  }
}
.imageName {
  padding: 5px 10px;
  height: 50px;
  // background-color: rgba(0, 0, 0,.2);
  // color:#fff;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: -1px;
  right: -1px;
  z-index: 2;
  font-size: 13px;
  line-height: 16px;
}
.videoWrap {
  height: 156px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.materialName{
  padding: 0 10px;
  display: flex;
  height: 36px;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
}
</style>
